<script setup lang="ts">
import { onUnmounted } from "vue";
import { DOMSVGUtil } from "@zyzgroup/core-web";
import Box from "../base/Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    canvasWidth?: string;
    canvasHeight?: string;
    borderColor?: string;
    brushSize?: number;
    brushDensity?: number;
    brushColor?: string;
    downloadFileName?: string;
  }>(),
  {
    canvasWidth: "400",
    canvasHeight: "300",
    borderColor: "#000000",
    brushSize: 4,
    brushDensity: 200,
    brushColor: "#000000",
    downloadFileName: "手写图片"
  }
);

let download = () => {};
let unsubscribe = () => {};

function start(drawContext) {
  const options = {
    brushSize: props.brushSize,
    brushDensity: props.brushDensity,
    brushColor: props.brushColor
  };
  unsubscribe = drawContext.drawMouseMoveLine(options);
  // unsubscribe = drawContext.drawMouseMoveBrush(options); // brush 暂时无法转换为svg

  download = () => {
    DOMSVGUtil.downloadFromSVGString(
      drawContext.ctx.toRawSVG().raw,
      props.downloadFileName
    );
  };
}

onUnmounted(() => {
  unsubscribe();
});

defineExpose({ download: () => download() });
</script>

<template>
  <div
    class="hand-write-panel"
    :style="{
      width: props.canvasWidth + 'px',
      height: props.canvasHeight + 'px',
      border: `1px solid ${borderColor}`
    }"
  >
    <Box
      type="canvas"
      :enableCustomContext="true"
      @start="start"
    ></Box>
  </div>
</template>
